import React from 'react';
import { TextInput } from '@carbon/react';

export default function TextFieldControl(props) {
  return <TextInput {...props}></TextInput>;
}
